import React from "react";
import SLDGenerate from "../../pages/DesignAssetsReport";
import MyErrorBoundary from "../../utils/ErrorBoundary";
import { useAtom } from "jotai";
import { projectAtomList } from "../../atoms";

const GenerateReport = ({
  status,
  reportStatus,
  closeOpenReportPopUp,
  handleCheckBoxChange,
  handleCheckBoxChangeAll,
  uploadReport,
  uploadSLDStatus,
  handleChangeName,
}) => {
  const [currentProject, setCurrentProject] = useAtom(projectAtomList)
  return (
    <MyErrorBoundary>
      <se-dialog id="AlertDialog" open={true} can-backdrop="false">
        <se-dialog-header>Generate Report</se-dialog-header>
        <se-dialog-content>
          <div className="col-md-12 generateReportDiv">
            <div className="row">
              <div className="col-md-12">
                {reportStatus?.showSeletOption === true && (
                  <div className="form-group row mb-0 text-center">
                    <div className="col-md-12">
                      <label className="col-sm-12 col-form-label infoText">
                        <se-icon size="nano" color="secondary">
                          information_circle
                        </se-icon>
                        <span>
                          {" "}
                          At least one option should be selected to download
                          report{" "}
                        </span>
                      </label>
                    </div>
                  </div>
                )}

                <div className="form-group row">
                  <div className="col-md-4">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox1"
                        name="selectAll"
                        checked={reportStatus?.selectAll}
                        onChange={handleCheckBoxChangeAll}
                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox1"
                      >
                        Select all options
                      </label>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div
                      className="form-group row"
                      style={{ position: "relative" }}
                    >
                      <label
                        htmlFor="inputEmail3"
                        className="label-align text-left bold"
                      >
                        Prepared By -<span className="se-mandatory">*</span>
                      </label>
                      <div className="col-md-8">
                        <input
                          type="text"
                          autoComplete="none"
                          className="form-control form-control-md"
                          name="communicationModel"
                          placeholder="Prepared By Name"
                          value={reportStatus?.loggedInUser}
                          maxLength="50"
                          onChange={handleChangeName}
                        />
                        <div
                          className="invalid-feedback-custom"
                          style={{
                            position: "absolute",
                            top: "100%",
                            left: "0",
                            width: "100%",
                            color: "red",
                            marginLeft: "15px",
                            display:
                              reportStatus?.loggedInUser === ""
                                ? "block"
                                : "none",
                          }}
                        >
                          {reportStatus?.loggedInUser === ""
                            ? "Prepared By is required."
                            : " "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox2"
                        name="information"
                        checked={reportStatus?.information}
                        onChange={handleCheckBoxChange}
                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox2"
                      >
                        Information
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox3"
                        name="sld"
                        checked={reportStatus?.sld}
                        onChange={handleCheckBoxChange}
                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox3"
                      >
                        Configure DER's
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox4"
                        name="program"
                        checked={reportStatus?.program}
                        onChange={handleCheckBoxChange}
                        disabled={!(currentProject?.showUseCase && currentProject?.showSystems)}
                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox4"
                      >
                        Configure usecases
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox5"
                        name="bom"
                        checked={reportStatus?.bom}
                        onChange={handleCheckBoxChange}
                        disabled={!currentProject?.showBOM}

                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox5"
                      >
                        BOM
                      </label>
                    </div>
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox6"
                        name="system"
                        checked={reportStatus?.system}
                        onChange={handleCheckBoxChange}
                        disabled={!(currentProject?.showSystems && currentProject?.showDeploy)}

                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox6"
                      >
                        System settings
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        className="custom-control-input asCompatible"
                        id="Checkbox7"
                        name="deploy"
                        checked={reportStatus?.deploy}
                        onChange={handleCheckBoxChange}
                        disabled={!currentProject?.showDeploy}

                      />
                      <label
                        className="custom-control-label line-height-25"
                        htmlFor="Checkbox7"
                      >
                        Deploy
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {status?.reportReadyStatus === true && (
              <SLDGenerate sldStatusCheck={uploadSLDStatus} />
            )}
          </div>
        </se-dialog-content>
        <se-dialog-footer>
          <se-button onClick={closeOpenReportPopUp}>Cancel</se-button>

          <se-button disabled={reportStatus?.loggedInUser===""} onClick={uploadReport}>Download Report</se-button>
        </se-dialog-footer>
      </se-dialog>
    </MyErrorBoundary>
  );
};

export default GenerateReport;
